
  import { computed, defineComponent, onMounted, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';
  import Multiselect from '@vueform/multiselect';

  export default defineComponent({
    name: 'promotion-creating',
    components: {
      ErrorMessage,
      Field,
      Form,
      Multiselect,
    },
    async setup() {
      const { t, te } = useI18n();
      const { can } = useAbility();
      const store = useStore();
      const router = useRouter();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const multiselect = ref<{ noOptions: boolean } | null>(null);
      const selectedpromotions = ref<Array<number>>([]);
      const loading = ref(false);
      const createdPromotion = ref<any | null>(null);
      const selectedPackageId = ref<number>(0);
      const selectedInfluencerId = ref<number>(0);
      const allInfluencers = computed(
        () => store.getters.allInfluencersList || []
      );
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('promotionCreating'), [
          translate('promotions'),
        ]);
        store.dispatch(Actions.GET_ALL_PACKAGES);
        store.dispatch(Actions.GET_ALL_INFLUENCERS);
      });
      const packages = computed(() => store.getters.allPackagesList);

      console.log(allInfluencers.value, 'all influencers');

      const goBack = () => {
        router.back();
      };

      const promotionSchema = Yup.object().shape({
        titleAr: Yup.string().required(() =>
          translate('AR_TITLE_IS_REQUIRED_FIELD')
        ),
        titleEn: Yup.string().required(() =>
          translate('EN_TITLE_IS_REQUIRED_FIELD')
        ),
        promoCode: Yup.string().required(() =>
          translate('PROMO_CODE_IS_REQUIRED_FIELD')
        ),
        discountPercentage: Yup.number().required(() =>
          translate('DISCOUNT_PERCENTAGE_IS_REQUIRED_FIELD')
        ),
        allowedUsage: Yup.number().required(() =>
          translate('ALLOWED_USAGE_IS_REQUIRED_FIELD')
        ),
        duration: Yup.number().required(() =>
          translate('DURATION_IS_REQUIRED_FIELD')
        ),
      });

      const onSubmitCreate = async (values) => {
        if (submitButton.value) {
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        if (values.packageId) values.packageId = Number(values.packageId);
        if (values.discountPercentage)
          values.discountPercentage = Number(values.discountPercentage);
        if (values.allowedUsage)
          values.allowedUsage = Number(values.allowedUsage);
        if (values.duration) values.duration = Number(values.duration);
        if (values.expiryAt) values.expiryAt = new Date(values.expiryAt);

        const result = await store.dispatch(Actions.CREATE_PROMOTION, values);
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];
        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        } else {
          createdPromotion.value = result;
          Swal.fire({
            text: translate('SUCCESSFULLY_ADDED_PROMOTION'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'promotions-listing' });
          });
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        promotions: computed(() => store.getters.promotionsList),
        onSubmitCreate,
        submitButton,
        translate,
        promotionSchema,
        packages,
        goBack,
        can,
        selectedpromotions,
        multiSelectLabel: 'title',
        loading,
        multiselect,
        createdPromotion,
        selectedPackageId,
        allInfluencers,
        selectedInfluencerId,
      };
    },
  });
